import { apiGet, apiPost, apiPut, apiDelete, throwApiError } from "../utils";

export const getMatchEventsAdmin = async (page, perPage, search = "") => {
  const response = await apiGet("/match-event", { page, perPage, search });
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const createMatchEvent = async (matchId, payload) => {
  const response = await apiPost(`/match-event`, { matchId, ...payload });
  const { message, ...event } = await response.json();

  throwApiError(message);

  return event;
};

export const updateMatchEvent = async (id, payload) => {
  const response = await apiPut(`/match-event/${id}`, payload);
  const { message, ...event } = await response.json();

  throwApiError(message);

  return event;
};

export const deleteMatchEvent = async (id) => {
  const response = await apiDelete(`/match-event/${id}`);
  if (response.status === 204) {
    return {};
  }

  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};
